<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.xiao_xi_ming_cheng')" prop="triggerCodeName">
              <el-input v-model="form.triggerCodeName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.xiao_xi_bian_ma')" prop="triggerCode">
              <el-input v-model="form.triggerCode" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.xiao_xi_lei_xing')" prop="msgType">
              <custom-select v-model="form.msgType" code="bas_msg_type" :placeholder="$t('Common.com_please_select')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.xiao_xi_mu_ban')" prop="templGroupId">
              <custom-select
                v-model="form.templGroupId"
                :placeholder="$t('Common.com_please_select')"
                :props="{ label: 'name', value: 'value' }"
                type="tree"
                url="MsgTemplateGroupTree"
                :show-all-levels="false"
                :params="{}"
                @treeValChange="templGroupIdChange"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.tui_song_fan_wei')" prop="pushRange">
              <custom-select
                v-model="form.pushRange"
                code="bas_org_type"
                :model="form"
                :props="{ label: 'name', value: 'value', map: { name: 'pushRangeName' } }"
                :placeholder="$t('Common.com_please_select')"
                multiple
                :multiple-limit="5"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.tui_song_jue_se')" prop="pushRole">
              <custom-select
                v-model="form.pushRole"
                url="roleMsgList"
                :model="form"
                :props="{ label: 'roleName', value: 'roleCode', map: { roleName: 'pushRoleName' } }"
                :placeholder="$t('Common.com_please_select')"
                multiple
                :multiple-limit="5"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_pushConfig_item_dialog.tui_song_qu_dao')" prop="pushChannel">
              <custom-select
                v-model="form.pushChannel"
                code="bas_msg_send_channel"
                :model="form"
                :props="{ label: 'name', value: 'value', map: { name: 'pushChannelName' } }"
                :placeholder="$t('Common.com_please_select')"
                multiple
                :multiple-limit="5"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      appTree: [],
      form: {
        triggerCodeName: '',
        triggerCode: '',
        msgType: '',
        pushRange: '',
        pushRangeName: [],
        pushRole: '',
        pushRoleName: [],
        pushChannel: '',
        pushChannelName: [],
        templGroupId: null,
        templGroupCode: '',
        // pushRangeName: '',
      },
      // 配置的ID
      pushConfId: '',
      editOff: false,
      templateList: [],
      pushRoleList: [],
      msgTemplateGroupTree: [],
      parentIdOff: false,
    };
  },
  computed: {
    rules() {
      return {
        triggerCodeName: {
          required: true,
          message: this.$t('base_pushConfig_item_dialog.xxmcbt'),
        },
        triggerCode: {
          required: true,
          message: this.$t('base_pushConfig_item_dialog.xxbmbt'),
        },
        msgType: {
          required: true,
          message: this.$t('base_pushConfig_item_dialog.xxlxbx'),
        },
        pushRange: {
          required: true,
          type: 'array',
          message: this.$t('base_pushConfig_item_dialog.tsgwbx'),
        },
        pushRole: {
          required: true,
          type: 'array',
          message: this.$t('base_pushConfig_item_dialog.tsdxbx'),
        },
        pushChannel: {
          required: true,
          type: 'array',
          message: this.$t('base_pushConfig_item_dialog.tsqdbx'),
        },
        templGroupId: {
          required: true,
          message: this.$t('base_pushConfig_item_dialog.xxmbbx'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.getDictionary('bas_msg_send_channel,bas_org_type,spring_cloud_msg_fault_grade,bas_msg_type');
      this.getTemplateTree();
      this.getUserRoleList();
      if (this.model.type === 'add') {
        this.editOff = false;
        return;
      }
      if (this.model.type === 'edit') {
        this.form.triggerCodeName = this.model.data.triggerCodeName;
        this.form.triggerCode = this.model.data.triggerCode;
        this.form.msgType = `${this.model.data.msgType}`;
        this.form.pushRange = this.model.data.pushRange;
        this.form.pushRole = this.model.data.pushRole;
        this.form.pushChannel = this.model.data.pushChannel;
        this.form.templGroupCode = this.model.data.templGroupCode;
        this.form.templGroupId = this.model.data.templGroupId;
        this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
    },

    // 下拉树select change
    templGroupIdChange: function (nodes) {
      if (nodes.length) {
        this.form.templGroupCode = nodes[nodes.length - 1].code;
      } else {
        this.form.templGroupCode = '';
      }
    },
    // 推送岗位
    getUserRoleList: function () {
      this.$getJSON(apis.roleMsgList).then((res) => {
        this.pushRoleList = res.data;
      });
    },
    // 获取消息推送模板树
    getTemplateTree: function () {
      this.$getJSON(`${apis.MsgTemplateGroupTree}`).then((res) => {
        this.templateList = res.data;
      });
    },
    getTreeProp(data, propName, defaultVal = '') {
      if (Array.isArray(data[propName])) {
        const len = Math.max(data[propName].length - 1, 0);
        return data[propName][len] || defaultVal;
      }
      return data[propName] || defaultVal;
    },
    getReqData() {
      return {
        ...this.form,
        templGroupId: this.getTreeProp(this.form, 'templGroupId'),
      };
    },
    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.pushChannelName = this.form.pushChannel.map((item) => {
          const index = this.propertyMap.bas_msg_send_channel.find((t) => t.value === item) || {};
          return index.name;
        });
        this.form.pushRangeName = this.form.pushRange.map((item) => {
          const index = this.propertyMap.bas_org_type.find((t) => t.value === item) || {};
          return index.name;
        });
        this.form.pushRoleName = this.form.pushRole.map((item) => {
          const index = this.pushRoleList.find((t) => t.roleCode === item) || {};
          return index.roleName;
        });
        // const codeObject = this.propertyMap.spring_cloud_msg_fault_grade.find(
        //   t => t.value === this.form.triggerCode
        // );
        // this.form.triggerCodeName = codeObject
        //   ? codeObject.name
        //   : this.form.triggerCode;

        // 赋值 code name id
        if (this.model.type === 'add') {
          this.saveAddItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditItem();
        }
      });
    },
    // 保存新增分组
    saveAddItem: function () {
      this.$postJSON(apis.PushConfSave, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    saveEditItem: function () {
      const pushConfId = this.pushConfId;
      const params = { ...this.getReqData(), pushConfId };
      this.$postJSON(apis.PushConfSave, params, true).then(() => {
        if (this.model.type === 'add') {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
        } else if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
        }
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
